import { useEffect, useState } from "react";

import { useValues } from "2g-form";
import { getCurrentMonday } from "b2b/utils/date";

export default function useSchedulerWeeks() {
  const values = useValues() || {};
  const [showPlaceholder, setShowPlaceholder] = useState(false);

  useEffect(() => {
    if (
      values.platnostOd &&
      values.platnostDo &&
      values.defaultMzo &&
      values.defaultVzo
    ) {
      setShowPlaceholder(true);
      setTimeout(() => {
        setShowPlaceholder(false);
      }, 100);
    }
  }, [
    values.platnostOd,
    values.platnostDo,
    values.defaultMzo,
    values.defaultVzo
  ]);

  const resolveItemState = ({ dateFrom, dateTo }) => {
    const currentMonday = getCurrentMonday();

    return {
      disabled: Boolean(values.id) && dateFrom < currentMonday,
      hidden:
        values._period?.yearFrom &&
        dateFrom.getFullYear() != values._period.yearFrom &&
        dateTo.getFullYear() != values._period.yearFrom
    };
  };

  return { values, showPlaceholder, resolveItemState };
}
